import { CommunityDiscussComments } from "../models/CommunityDiscussComments";
import { GetCreatedAtDate } from "./DateTransform";

export const CommentsGroup = (comments: CommunityDiscussComments[]) => {
    let _dates: Record<string, CommunityDiscussComments[]> = {};
    const sorted = [...comments].sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });

    sorted.forEach(c => {
        const _d = GetCreatedAtDate(c.createdAt);

        if (!_dates[_d])
            _dates[_d] = [c];
        else
            _dates[_d].push(c);
    });
    
    return _dates;
}